import { callApi } from "@/Utils/request/query";
import authApi from "@/types/auth/authApi";

/** Local logout is already complete; a slow server must not restore that session. */
export async function revokeSessionTokens(
  access: string,
  refresh: string,
): Promise<boolean> {
  try {
    await callApi(
      { ...authApi.logout, noAuth: true },
      {
        headers: { Authorization: `Bearer ${access}` },
        body: { access, refresh },
        silent: true,
        signal: AbortSignal.timeout(3000),
      },
    );
    return true;
  } catch {
    return false;
  }
}
